export default {
  en: {
    why_we_recommend_the_freelancer_plan:
      "Why we recommend the Plus Plan for Freelancers",

    freelancer_plan_description_1:
      "The Plus Plan is perfect for freelancers who want to keep track of their time and earnings. With features like PDF and CSV reports, manageable activities, and revenue dashboards, you can easily stay on top of your data and make informed decisions.",
    freelancer_plan_description_2:
      'For freelancers, time tracking and billing can be a hassle. With the Plus Plan, you can simplify these tasks by managing activities like "Development". Track every task with ease to ensure accurate billing.',
    get_started_with_plus: "Get started with the Plus Plan today!",
  },
  de: {
    why_we_recommend_the_freelancer_plan:
      "Warum wir den Plus-Tarif für Freelancer empfehlen",

    freelancer_plan_description_1:
      "Der Plus-Tarif ist ideal für Freelancer, die ihre Zeit und Einnahmen im Blick behalten möchten. Mit Funktionen wie PDF- und CSV-Berichten, verwaltbaren Aktivitäten und Umsatz-Dashboards kannst du deine Daten einfach im Auge behalten und fundierte Entscheidungen treffen.",

    freelancer_plan_description_2:
      'Für Freelancer kann die Zeiterfassung und Abrechnung eine Herausforderung sein. Mit dem Plus-Tarif kannst du diese Aufgaben vereinfachen, indem du Aktivitäten wie "Entwicklung" verwaltest. Verfolge jede Aufgabe mühelos, um eine genaue Abrechnung sicherzustellen.',

    get_started_with_plus: "Starte noch heute mit dem Plus-Tarif!",
  },
};
